import React from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { UserCheck, ArrowLeft } from 'lucide-react'
import ContentEditorForm from '../shared/ContentEditorForm'

const AdminContentEditor = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const siteId     = searchParams.get('site')
  const clientId   = searchParams.get('clientId')
  const clientName = searchParams.get('clientName') || 'Client'

  const handleExit = () => navigate('/admin/sites')

  return (
    <div>
      {/* Impersonation banner */}
      <div
        className="flex items-center justify-between"
        style={{
          padding: '0.625rem 1.5rem',
          background: 'rgba(245,158,11,0.08)',
          borderBottom: '1px solid rgba(245,158,11,0.3)',
          margin: '-1.5rem -1.5rem 1.5rem'
        }}
      >
        <div className="flex items-center" style={{ gap: '0.5rem', fontSize: '0.875rem', color: 'var(--warning)' }}>
          <UserCheck style={{ width: '1rem', height: '1rem', flexShrink: 0 }} />
          <span>
            Editing on behalf of <span className="font-semibold">{clientName}</span>
            {' '}— changes save directly to their site.
          </span>
        </div>
        <button
          className="btn btn-ghost btn-sm flex items-center gap-1"
          onClick={handleExit}
          style={{ color: 'var(--warning)', flexShrink: 0 }}
        >
          <ArrowLeft style={{ width: '0.875rem', height: '0.875rem' }} />
          Exit to Admin
        </button>
      </div>

      {siteId ? (
        <ContentEditorForm
          siteId={siteId}
          clientId={clientId}
          onBack={handleExit}
          showRequestChange={false}
        />
      ) : (
        <div className="flex col items-center justify-center" style={{ height: '16rem', gap: '1rem' }}>
          <p className="text-muted">No site selected.</p>
          <button className="btn btn-ghost" onClick={handleExit}>Back to Sites</button>
        </div>
      )}
    </div>
  )
}

export default AdminContentEditor
